import { RoleType, SiiaPermissionType } from '../models/role-type';

export const siiaRolesMap = new Map<RoleType, string[]>([
  [
    RoleType.Admin,
    [
      '32ab13a3-5396-ec11-b400-000d3ab9bcbb',
      'c7c047a9-5396-ec11-b400-000d3ab9bcbb',
    ],
  ],
  [
    RoleType.Provider,
    [
      '292a938c-5e96-ec11-b400-000d3ab9bb64',
      'cb58cc06-0294-ec11-b400-000d3ab9bcbb',
      'c385860d-7ea4-ec11-983f-0022489ef0b6',
      '05bbaf1f-7ea4-ec11-983f-0022489ef0b6',
      'b05ed7f4-0194-ec11-b400-000d3ab9bcbb',
      'd6a92b53-5f96-ec11-b400-000d3ab9bb64',
    ],
  ],
  [
    RoleType.Consumer,
    [
      'f5ab12a2-5e96-ec11-b400-000d3ab9bb64',
      'f9a52d80-5e96-ec11-b400-000d3ab9bb64',
      'f2e98201-7ea4-ec11-983f-0022489ef0b6',
      '06e0aff4-7da4-ec11-983f-0022489ef0b6',
      'c7c047a9-5396-ec11-b400-000d3ab9bcbb',
      'c8d0296d-5596-ec11-b400-000d3ab9bcbb',
      '17eddae8-0194-ec11-b400-000d3ab9bcbb',
      '15df733d-6396-ec11-b400-000d3ab9bb64',
      '205bbe4a-6396-ec11-b400-000d3ab9bb64',
      'd1351854-6396-ec11-b400-000d3ab9bb64',
      '5309f1ca-b9aa-ec11-983f-000d3ab55e4a',
      '1157bce5-c3aa-ec11-9840-000d3ab45452',
      '0d57bce5-c3aa-ec11-9840-000d3ab45452',
      '0557bce5-c3aa-ec11-9840-000d3ab45452',
      '0957bce5-c3aa-ec11-9840-000d3ab45452',
      '2b0f3080-c3aa-ec11-983f-000d3ab55e4a',
      '1357bce5-c3aa-ec11-9840-000d3ab45452',
      '0f57bce5-c3aa-ec11-9840-000d3ab45452',
      '0757bce5-c3aa-ec11-9840-000d3ab45452',
      '0b57bce5-c3aa-ec11-9840-000d3ab45452',
      '2c7a0697-5396-ec11-b400-000d3ab9bcbb',
      'e5cd55b2-c3e0-ec11-bb3c-0022489b1552',
    ],
  ],
  [
    RoleType.OccurrencesAdmin,
    [
      // #region OccurrencesAdmin - DEV
      '2b0f3080-c3aa-ec11-983f-000d3ab55e4a',
      '1357bce5-c3aa-ec11-9840-000d3ab45452',
      '0f57bce5-c3aa-ec11-9840-000d3ab45452',
      '0757bce5-c3aa-ec11-9840-000d3ab45452',
      '0b57bce5-c3aa-ec11-9840-000d3ab45452',
      // #endregion

      // #region OccurrencesAdmin - STG
      '2b0f3080-c3aa-ec11-983f-000d3ab55e4a',
      '1357bce5-c3aa-ec11-9840-000d3ab45452',
      '0f57bce5-c3aa-ec11-9840-000d3ab45452',
      '0757bce5-c3aa-ec11-9840-000d3ab45452',
      '0b57bce5-c3aa-ec11-9840-000d3ab45452',
      // #endregion

      // #region OccurrencesAdmin - QUAL
      '2b0f3080-c3aa-ec11-983f-000d3ab55e4a',
      '1357bce5-c3aa-ec11-9840-000d3ab45452',
      '0f57bce5-c3aa-ec11-9840-000d3ab45452',
      '0757bce5-c3aa-ec11-9840-000d3ab45452',
      '0b57bce5-c3aa-ec11-9840-000d3ab45452',
      // #endregion

      // #region OccurrencesAdmin - PROD
      '0757bce5-c3aa-ec11-9840-000d3ab45452',
      '0b57bce5-c3aa-ec11-9840-000d3ab45452',
      '0f57bce5-c3aa-ec11-9840-000d3ab45452',
      '1357bce5-c3aa-ec11-9840-000d3ab45452',
      '2b0f3080-c3aa-ec11-983f-000d3ab55e4a',
      // #endregion
    ],
  ],
  [
    RoleType.OccurrencesSupervisor,
    [
      // #region OccurrencesSupervisor - DEV
      'e5cd55b2-c3e0-ec11-bb3c-0022489b1552',
      // #endregion

      // #region OccurrencesSupervisor - STG
      '3ea9b01b-d538-ed11-9db1-000d3ad8af2e',
      // #endregion

      // #region OccurrencesSupervisor - QUAL
      'e5cd55b2-c3e0-ec11-bb3c-0022489b1552',
      // #endregion

      // #region OccurrencesSupervisor - QUAL
      'e5cd55b2-c3e0-ec11-bb3c-0022489b1552',
      // #endregion
    ],
  ],
]);

export const siiaPermissionsRolesMap = new Map<
  SiiaPermissionType,
  {
    allowed?: string[];
    notallowed?: string[];
  }
>([
  [
    SiiaPermissionType.CreateOccurrence,
    {
      notallowed: [
        '17eddae8-0194-ec11-b400-000d3ab9bcbb',
        '15df733d-6396-ec11-b400-000d3ab9bb64',
        '205bbe4a-6396-ec11-b400-000d3ab9bb64',
        'd1351854-6396-ec11-b400-000d3ab9bb64',
        '5309f1ca-b9aa-ec11-983f-000d3ab55e4a',
        '1157bce5-c3aa-ec11-9840-000d3ab45452',
        '0d57bce5-c3aa-ec11-9840-000d3ab45452',
        '0957bce5-c3aa-ec11-9840-000d3ab45452',
      ],
    },
  ],
  [
    SiiaPermissionType.PublishOccurrence,
    {
      allowed: [
        'e5cd55b2-c3e0-ec11-bb3c-0022489b1552',
        '32ab13a3-5396-ec11-b400-000d3ab9bcbb',
        'c7c047a9-5396-ec11-b400-000d3ab9bcbb',
      ],
    },
  ],
  [
    SiiaPermissionType.CancelOccurrence,
    {
      allowed: [
        'e5cd55b2-c3e0-ec11-bb3c-0022489b1552',
        '32ab13a3-5396-ec11-b400-000d3ab9bcbb',
        'c7c047a9-5396-ec11-b400-000d3ab9bcbb',
      ],
    },
  ],
  [
    SiiaPermissionType.AcceptOccurrence,
    {
      allowed: [
        '292a938c-5e96-ec11-b400-000d3ab9bb64',
        'f9a52d80-5e96-ec11-b400-000d3ab9bb64',
        'c385860d-7ea4-ec11-983f-0022489ef0b6',
        '05bbaf1f-7ea4-ec11-983f-0022489ef0b6',
        '32ab13a3-5396-ec11-b400-000d3ab9bcbb',
        'c7c047a9-5396-ec11-b400-000d3ab9bcbb',
      ],
    },
  ],
  [
    SiiaPermissionType.ResolveOccurrence,
    {
      allowed: [
        '292a938c-5e96-ec11-b400-000d3ab9bb64',
        'f9a52d80-5e96-ec11-b400-000d3ab9bb64',
        'c385860d-7ea4-ec11-983f-0022489ef0b6',
        '05bbaf1f-7ea4-ec11-983f-0022489ef0b6',
        '32ab13a3-5396-ec11-b400-000d3ab9bcbb',
        'c7c047a9-5396-ec11-b400-000d3ab9bcbb',
      ],
    },
  ],
]);
